import { Navigate } from "react-router-dom";
import { ConsultantuseAuth } from "./ConsultantUseAuth";

export const ConsultantProtectedRoute = ({ children }) => {
  const { user } = ConsultantuseAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/Consultant/login" />;
  }
  return children;
};
